<app-spinner *ngIf="loading$ | async; else content;"></app-spinner>

<ng-template #content>
  <section id="fs5" *ngIf="featuredBook"  >
    <h3>Purchase Information</h3>
    <hr *ngIf="variant === 'control'"/>
    <div class="block top" [class]="{'new-block': variant === 'experimental'}">
      <div class="left-side">
        <div class="book-side">
          <div class="image">
            <img [src]="featuredBook?._book?.amazonImageUrl ? featuredBook._book.amazonImageUrl : defaultCoverImage" />
          </div>
          <div class="book-info">
            <p><strong>{{featuredBook._book.title}}</strong></p>
            <p>{{featuredBook._book.author}}</p>
          </div>
        </div>
        <p>{{featuredBook.description}}</p>
      </div>
      <div class="right-side" [class]="{'remove-border': variant === 'experimental'}">

        <div class="flex flex-column h-full" *ngIf="variant === 'experimental'; else standard">
          <div class="flex-grow-1 align-content-center border-bottom-light">
            <p><strong>{{featuredBook._site.name}}</strong> - {{featuredBook._siteAdvert.name}}</p>
              <p *ngIf="featuredBook && !featuredBook.endPubDate">
                <i>Running on {{moment(featuredBook.pubDate, 'YYYYMMDD').format("dddd, MMM D, YYYY")}}</i>
              </p>
              <p *ngIf="featuredBook && featuredBook.endPubDate">
                <i>Starting on {{ moment(featuredBook.pubDate, 'YYYYMMDD').format("dddd, MMM D, YYYY") }}</i>
              </p>
          </div>
          <div class="flex-grow-1 align-content-center border-bottom-light">
            <div class="promo flex">
              <input class="promo-code flex-grow-1" type="text" placeholder="Promo Code" [(ngModel)]="promoCodeCommon" />
              <button type="button" class="regular button  solid-green tall" (click)="applyPromoCode(promoCodeCommon)">Apply</button>
              <div class="error">{{promoError}}</div>
            </div>
          </div>
          <div class="flex-grow-1 align-content-center">
            <div class="payment-line">
              <div class="label">Subtotal</div>
              <div class="amount">{{featuredBook._siteAdvert.price | currency:'USD'}}</div>
            </div>
            <div class="payment-line" *ngIf="applicationResult">
              <div class="label" *ngIf="discountText">
                {{discountText}}
                <span *ngIf="applicationResult.type === 'percent'"> ({{applicationResult.value}}%)</span>:
              </div>
              <div class="amount">({{discountAmount | currency:'USD'}})</div>
            </div>
            <div class="payment-line">
              <div class="label total">Total</div>
              <div class="amount total">{{paymentAmount | currency:'USD'}}</div>
            </div>
          </div>
        </div>
        <ng-template #standard>
          <p><strong>{{featuredBook._site.name}}</strong> - {{featuredBook._siteAdvert.name}}</p>
          <p *ngIf="featuredBook && !featuredBook.endPubDate">
            <i>Running on {{moment(featuredBook.pubDate, 'YYYYMMDD').format("dddd, MMM D, YYYY")}}</i>
          </p>
          <p *ngIf="featuredBook && featuredBook.endPubDate">
            <i>Starting on {{ moment(featuredBook.pubDate, 'YYYYMMDD').format("dddd, MMM D, YYYY") }}</i>
          </p>
          <hr/>
          <div class="promo">
            <input type="text" placeholder="Promo Code" [(ngModel)]="promoCodeCommon" />
            <button type="button" class="regular button  solid-green" (click)="applyPromoCode(promoCodeCommon)">Apply</button>
            <div class="error">{{promoError}}</div>
          </div>
          <hr/>
          <div class="payment-line">
            <div class="label">Subtotal</div>
            <div class="amount">{{featuredBook._siteAdvert.price | currency:'USD'}}</div>
          </div>
          <div class="payment-line" *ngIf="(featuredBook._promoCode && !promoCode) || discountAmount > 0">
            <div class="label" *ngIf="discountText">
              {{discountText}}
              <span *ngIf="applicationResult.type === 'percent'"> ({{applicationResult.value}}%)</span>:
            </div>
            <div class="amount">({{discountAmount | currency:'USD'}})</div>
          </div>
          <div class="payment-line">
            <div class="label total">Total</div>
            <div class="amount total">{{paymentAmount | currency:'USD'}}</div>
          </div>
        </ng-template>
      </div>
    </div>
    <hr *ngIf="variant === 'control'"/>
    <div class="edit-add-to-cart flex align-items-center">
      <button type="button" 
        class="regular button solid-green add-to-cart" 
        (click)="addToCart()">{{addingToCart ? 'Adding to Cart...' : 'Add to Cart' }}</button>
        <a class="edit-promotion" (click)="handleEdit()">Edit Promotion</a>
      </div>
  </section>
</ng-template>
<app-upsell-modal
  [featureImage]="featuredBook && featuredBook._book && featuredBook._book.amazonImageUrl ? featuredBook._book.amazonImageUrl : defaultCoverImage"
  [visible]="isUpsellVisible"
  [upsell]="upsell"
  [applyingDiscount]="upsellApplyingDiscount"
  [paymentAmount]="upsellPaymentAmount" 
  (acceptUpsell)="acceptUpsell()"
  (closeUpsell)="closeUpsellModal()"
></app-upsell-modal>
<app-new-error-modal [options]="errorOptions" modalId="fs5-error-modal"></app-new-error-modal>
